import { render, staticRenderFns } from "./Culture.vue?vue&type=template&id=6ae49253&scoped=true"
import script from "./Culture.vue?vue&type=script&lang=js"
export * from "./Culture.vue?vue&type=script&lang=js"
import style0 from "./Culture.vue?vue&type=style&index=0&id=6ae49253&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae49253",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae49253')) {
      api.createRecord('6ae49253', component.options)
    } else {
      api.reload('6ae49253', component.options)
    }
    module.hot.accept("./Culture.vue?vue&type=template&id=6ae49253&scoped=true", function () {
      api.rerender('6ae49253', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/Culture.vue"
export default component.exports